import * as React from 'react';

import clsx from 'clsx';

import { Text } from './Text';
import type { TextProps } from './Text';

// Mapping for form component sizes to HelpText sizes
const sizeMapping = {
  small: '3xsmall',
  medium: '2xsmall',
  large: '2xsmall',
  default: '2xsmall',
} as const;

export interface HelpTextProps extends Omit<TextProps, 'size' | 'color'> {
  error?: boolean;
  size?: keyof typeof sizeMapping;
}

/**
 * HelpText component displays helper or error text below a form field.
 * Built on top of our Text component with Radix UI Text underneath.
 */
export const HelpText = React.forwardRef<HTMLElement, HelpTextProps>(
  ({ className, error, size = 'default', children, ...props }, ref) => {
    const mappedSize =
      sizeMapping[size as keyof typeof sizeMapping] || sizeMapping.default;
    const textColor = error ? 'error' : 'secondary';

    return (
      <Text
        ref={ref}
        as="div"
        size={mappedSize}
        color={textColor}
        className={clsx('helptext', { 'helptext--error': error }, className)}
        {...props}
      >
        {children}
      </Text>
    );
  }
);

HelpText.displayName = 'HelpText';
